import styled from "styled-components";

import useRevitBuiltInParameter from "./useRevitBuiltInParameter";
import { Card, CardFace, CardSkeleton, LetterBackdrop } from "../../../../modules/ui-kit";


const Styled = styled(CardFace)`
    & > :first-child {
        font-size: 1.8em;
    }

    & > :nth-child(2) {
        font-size: .7rem;
        opacity: .4;
    }

    & > :nth-child(3) {
        font-size: .7rem;
        opacity: .4;
    }
`;

export default function RevitBuiltInParameter(props) {
    const { id, ...restProps } = props;

    const builtInParameterQuery = useRevitBuiltInParameter(id);

    if (!id) return undefined;

    if (builtInParameterQuery.loading) return <CardSkeleton />;
    if (builtInParameterQuery.error) return undefined;

    const name = (builtInParameterQuery.data.revitBuiltInParameter.name.find((x) => x.revitLocale === "ENU") ?? builtInParameterQuery.data.revitBuiltInParameter.name[0])?.text;

    return (
        <Card { ...restProps }>
            <LetterBackdrop>RBIP</LetterBackdrop>
            <Styled>
                <span className="fluid-accent">{ name }</span>
                <span>{ builtInParameterQuery.data.revitBuiltInParameter.key }</span>
                <span>{ id }</span>
            </Styled>
        </Card>
    );
}
